import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CheckCircleOutlineIcon(props: FixMe) {
  return <CheckCircleOutline {...props} />;
}

export default CheckCircleOutlineIcon;
